import { c as _c } from "react-compiler-runtime";
import { Flex } from 'foundations-components/components/Flex';
import { useSelectionSelector } from '../../redux/reduxHooks';
import BulkActionsContainer from '../../selection/components/BulkActionsContainer';
import { getShouldShowBulkActionsContainer } from '../../selection/redux/selectionSlice';
import { TABLE_TOP_BAR_HEIGHT } from '../constants/sizes';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function TableTopBar(t0) {
  const $ = _c(18);
  const {
    alternateHeaderLeftSlot,
    BulkActionsComponent,
    headerLeftSlot,
    headerRightSlot,
    isBulkActionsRedesignEnabled,
    isIndexRedesignEnabled,
    showSelectQuery,
    totalRowCount,
    hasTopBarBorderRadius,
    borderless
  } = t0;
  const shouldShowBulkActions = useSelectionSelector(getShouldShowBulkActionsContainer);
  const shouldOnlyShowBulkActions = shouldShowBulkActions && isBulkActionsRedesignEnabled;
  let t1;
  if ($[0] !== borderless || $[1] !== hasTopBarBorderRadius) {
    t1 = borderless ? {} : {
      borderColor: "border-core-subtle",
      borderStyle: "solid",
      borderWidth: "100",
      borderBlockEndStyle: "none",
      borderStartStartRadius: hasTopBarBorderRadius !== false ? "300" : undefined,
      borderStartEndRadius: hasTopBarBorderRadius !== false ? "300" : undefined
    };
    $[0] = borderless;
    $[1] = hasTopBarBorderRadius;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const borderProps = t1;
  const t2 = isBulkActionsRedesignEnabled ? "space-between" : "start";
  let t3;
  if ($[3] !== BulkActionsComponent || $[4] !== alternateHeaderLeftSlot || $[5] !== headerLeftSlot || $[6] !== headerRightSlot || $[7] !== isBulkActionsRedesignEnabled || $[8] !== isIndexRedesignEnabled || $[9] !== shouldOnlyShowBulkActions || $[10] !== shouldShowBulkActions || $[11] !== showSelectQuery || $[12] !== totalRowCount) {
    t3 = shouldOnlyShowBulkActions ? /*#__PURE__*/_jsx(BulkActionsContainer, {
      BulkActionsComponent: BulkActionsComponent,
      isBulkActionsRedesignEnabled: isBulkActionsRedesignEnabled,
      isIndexRedesignEnabled: isIndexRedesignEnabled,
      showSelectQuery: showSelectQuery,
      totalRowCount: totalRowCount
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [headerLeftSlot, !shouldShowBulkActions && alternateHeaderLeftSlot, shouldShowBulkActions && /*#__PURE__*/_jsx(BulkActionsContainer, {
        BulkActionsComponent: BulkActionsComponent,
        isBulkActionsRedesignEnabled: isBulkActionsRedesignEnabled,
        isIndexRedesignEnabled: isIndexRedesignEnabled,
        showSelectQuery: showSelectQuery,
        totalRowCount: totalRowCount
      }), /*#__PURE__*/_jsx(View, {
        marginInlineStart: "auto",
        as: "div",
        children: headerRightSlot
      })]
    });
    $[3] = BulkActionsComponent;
    $[4] = alternateHeaderLeftSlot;
    $[5] = headerLeftSlot;
    $[6] = headerRightSlot;
    $[7] = isBulkActionsRedesignEnabled;
    $[8] = isIndexRedesignEnabled;
    $[9] = shouldOnlyShowBulkActions;
    $[10] = shouldShowBulkActions;
    $[11] = showSelectQuery;
    $[12] = totalRowCount;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== borderProps || $[15] !== t2 || $[16] !== t3) {
    t4 = /*#__PURE__*/_jsx(Flex, Object.assign({
      alignItems: "center",
      backgroundColor: "fill-field-default",
      blockSize: TABLE_TOP_BAR_HEIGHT
    }, borderProps, {
      "data-test-id": "table-top-bar",
      flexBasis: TABLE_TOP_BAR_HEIGHT,
      inlineSize: "100%",
      justifyContent: t2,
      paddingInline: "100",
      children: t3
    }));
    $[14] = borderProps;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}
export default TableTopBar;